import Footer6 from './Footer6'
export default Footer6
